import { createSlice } from '@reduxjs/toolkit'
import { setNestedKey } from '../../helpers/common'
import { register } from '../../helpers/reducerRegistry'
import { TYPES_DISCOUNT } from '../../utils/common'
import { CHECKBOX_TRADE_DISCOUNT, PAYMENT_METHOD } from '../constant'
import {
  covertObjBooleanToArr,
  getPriceByCheck,
  handleCartItems,
  handleDataByTypeReport,
  handleDataPlaceOrder,
  handleListInteresting,
} from '../helper'
import {
  delCartItem,
  getBankTransferInfo,
  getCartItems,
  getDiscount,
  getMostPopularCompanies,
  getSimilarCompanies,
  getTerms,
  getUserPricingPackages,
  getUserProfile,
  getVoucher,
  postOrder,
  postOrderZero,
} from './thunk'

export const TYPE_REPORT_STORE = {
  FIINGATE_FACTSHEET: 'factSheet',
  BUSINESS_CREDIT: 'businessCreditReport',
}

export const TYPE_DATA_REPORT_STORE = {
  IDS: 'ids',
  BY_ID: 'byId',
}

const initialState = {
  dataDefault: [],
  data: {
    [TYPE_REPORT_STORE.FIINGATE_FACTSHEET]: {
      [TYPE_DATA_REPORT_STORE.IDS]: {},
      [TYPE_DATA_REPORT_STORE.BY_ID]: {},
    },
    [TYPE_REPORT_STORE.BUSINESS_CREDIT]: {
      [TYPE_DATA_REPORT_STORE.IDS]: {},
      [TYPE_DATA_REPORT_STORE.BY_ID]: {},
    },
    check: {},
    total: {
      totalPrice: 0,
      discountedPrice: 0,
      discountValue: 0,
      discountedPriceFactSheet: 0,
      discountedPriceBusiness: 0,
    },
  },
  userInformation: {
    customerName: '',
    companyName: '',
    companyAddress: '',
    invoiceReceivingEmail: '',
    taxCode: '',
    phone: '',
  },
  suggestionCompany: {
    similarCompany: [],
    popularCompany: [],
  },
  discountOrder: {},
  dataVoucher: {
    code: '',
    discountPercentage: 0,
    en_Description: '',
  },
  checkDisCountAndVoucher: {
    [CHECKBOX_TRADE_DISCOUNT.DISCOUNT]: true,
    [CHECKBOX_TRADE_DISCOUNT.VOUCHER]: false,
  },
  information: {},
  userPackage: [],
  disableOrder: {
    [PAYMENT_METHOD.PACKAGE]: false,
    [PAYMENT_METHOD.BANK_TRANSFERS]: false,
    [PAYMENT_METHOD.CARD]: false,
    [PAYMENT_METHOD.POST_PAID]: false,
  },
  isCheckRules: false,
  fragmentCart: false,
  paramsScreeningReport: {},
  defaultFormFactSheet: {
    language: {},
    currency: {},
    unit: {},
    currencyFS: {},
    unitFS: {},
  },
  codeBankTransfer: {},
  terms: '',
  paramsDiscount: [TYPES_DISCOUNT.Order],
  loading: {
    getCartItems: true,
    getDiscount: true,
    getVoucher: false,
    postOrder: false,
    postOrderZero: false,
    delCartItem: false,
    getUserPricingPackages: true,
    getBankTransferInfo: false,
    getSimilarCompanies: true,
    getMostPopularCompanies: true,
    getUserProfile: true,
    getTerms: true,
  },
}

const slice = createSlice({
  name: 'cartAndOrder',
  initialState,
  reducers: {
    resetStore: () => initialState,
    checkItem: (state, action) => {
      state.data.check[action.payload] = true
    },
    checkListItem: (state, { payload = [] }) => {
      payload.forEach((item) => {
        state.data.check[item] = true
      })
    },
    uncheckItem: (state, action) => {
      delete state.data.check[action.payload]
    },
    checkAll: (state, action) => {
      const key = action.payload
      if (key) {
        covertObjBooleanToArr(state.data[key].ids).forEach((id) => {
          state.data.check[id] = true
        })
      } else {
        ;[
          ...covertObjBooleanToArr(state.data.factSheet.ids),
          ...covertObjBooleanToArr(state.data.businessCreditReport.ids),
        ].forEach((id) => {
          state.data.check[id] = true
        })
      }
    },
    uncheckAll: (state, action) => {
      const key = action.payload
      if (key) {
        covertObjBooleanToArr(state.data[key].ids).forEach((id) => {
          delete state.data.check[id]
        })
      } else {
        state.data.check = {}
      }
    },
    changeUserInformation: (state, action) => {
      const { key, value } = action.payload
      state.userInformation[key] = value
    },
    changeDataReport: (state, action) => {
      const { path, data } = action.payload
      setNestedKey(state.data, path, data)
    },
    getPrice: (state) => {
      state.data.total = getPriceByCheck(
        state.dataDefault,
        covertObjBooleanToArr(state.data.check),
      )
    },
    changeCheckDiscountAndVoucher: (state, action) => {
      state.checkDisCountAndVoucher = {
        ...state.checkDisCountAndVoucher,
        ...action.payload,
      }
    },
    changeDisableOrder: (state, action) => {
      state.disableOrder = {
        ...state.disableOrder,
        ...action.payload,
      }
    },
    changeCheckRules: (state, action) => {
      state.isCheckRules = action.payload
    },
    changeFragment: (state) => {
      state.fragmentCart = !state.fragmentCart
    },
    getParamsScreeningReport: (state, action) => {
      state.paramsScreeningReport = action.payload
    },
    changeDefaultFormFactSheet: (state, action) => {
      state.defaultFormFactSheet = {
        ...state.defaultFormFactSheet,
        ...action.payload,
      }
    },
    changeParamsDiscount: (state, action) => {
      state.paramsDiscount = action.payload
    },
    changeVoucher: (state, action) => {
      state.dataVoucher = action.payload
    },
  },
  extraReducers: (builder) => {
    // Get Cart Items
    builder.addCase(getCartItems.pending, (state) => {
      state.loading.getCartItems = true
    })
    builder.addCase(getCartItems.fulfilled, (state, action) => {
      const userTypeId = action.meta.arg.userType
      state.data = {
        ...state.data,
        ...handleCartItems(action.payload, userTypeId),
      }
      state.dataDefault = action.payload
      state.loading.getCartItems = false
    })
    builder.addCase(getCartItems.rejected, (state, action) => {
      state.loading.getCartItems = action.payload.loading
    })

    //delete Cart Item
    builder.addCase(delCartItem.pending, (state) => {
      state.loading.delCartItem = true
    })
    builder.addCase(delCartItem.fulfilled, (state, action) => {
      state.loading.delCartItem = false
    })
    builder.addCase(delCartItem.rejected, (state, action) => {
      state.loading.delCartItem = action.payload.loading
    })

    //Place Order
    builder.addCase(postOrder.pending, (state) => {
      state.loading.postOrder = true
    })
    builder.addCase(postOrder.fulfilled, (state, action) => {
      state.loading.postOrder = false
    })
    builder.addCase(postOrder.rejected, (state, action) => {
      state.loading.postOrder = action.payload.loading
    })

    //Place OrderZero
    builder.addCase(postOrderZero.pending, (state) => {
      state.loading.postOrderZero = true
    })
    builder.addCase(postOrderZero.fulfilled, (state) => {
      state.loading.postOrderZero = false
    })
    builder.addCase(postOrderZero.rejected, (state, action) => {
      state.loading.postOrderZero = action.payload.loading
    })

    //getDiscount
    builder.addCase(getDiscount.pending, (state) => {
      state.loading.getDiscount = true
    })
    builder.addCase(getDiscount.fulfilled, (state, action) => {
      state.discountOrder = action.payload[0] || {}
      state.loading.getDiscount = false
    })
    builder.addCase(getDiscount.rejected, (state, action) => {
      state.loading.getDiscount = action.payload.loading
    })
    //getVoucher
    builder.addCase(getVoucher.fulfilled, (state, action) => {
      // state.dataVoucher = action.payload || {}
      state.loading.getVoucher = false
    })
    builder.addCase(getVoucher.rejected, (state, action) => {
      state.dataVoucher = initialState['dataVoucher']
      state.loading.getVoucher = action.payload.loading
    })
    //getUserPricingPackages
    builder.addCase(getUserPricingPackages.pending, (state) => {
      state.loading.getUserPricingPackages = true
    })
    builder.addCase(getUserPricingPackages.fulfilled, (state, action) => {
      state.userPackage = action.payload
      state.loading.getUserPricingPackages = false
    })
    builder.addCase(getUserPricingPackages.rejected, (state, action) => {
      state.loading.getUserPricingPackages = action.payload.loading
    })
    //getBankTransferInfo
    builder.addCase(getBankTransferInfo.pending, (state) => {
      state.codeBankTransfer = {}
      state.loading.getBankTransferInfo = true
    })
    builder.addCase(getBankTransferInfo.fulfilled, (state, action) => {
      state.codeBankTransfer = action.payload
      state.loading.getBankTransferInfo = false
    })
    builder.addCase(getBankTransferInfo.rejected, (state, action) => {
      state.loading.getBankTransferInfo = action.payload.loading
    })
    //get Similar Company
    builder.addCase(getSimilarCompanies.pending, (state) => {
      state.suggestionCompany.similarCompany = []
      state.loading.getSimilarCompanies = true
    })
    builder.addCase(getSimilarCompanies.fulfilled, (state, action) => {
      state.suggestionCompany.similarCompany = handleListInteresting(
        action.payload,
      )
      state.loading.getSimilarCompanies = false
    })
    builder.addCase(getSimilarCompanies.rejected, (state, action) => {
      state.loading.getSimilarCompanies = action.payload.loading
    })
    //get The Most Popular Company
    builder.addCase(getMostPopularCompanies.pending, (state) => {
      state.suggestionCompany.popularCompany = []
      state.loading.getMostPopularCompanies = true
    })
    builder.addCase(getMostPopularCompanies.fulfilled, (state, action) => {
      state.suggestionCompany.popularCompany = handleListInteresting(
        action.payload,
      )
      state.loading.getMostPopularCompanies = false
    })
    builder.addCase(getMostPopularCompanies.rejected, (state, action) => {
      state.loading.getMostPopularCompanies = action.payload.loading
    })
    //
    builder.addCase(getUserProfile.pending, (state) => {
      state.userInformation = {}
      state.loading.getUserProfile = true
    })
    builder.addCase(getUserProfile.fulfilled, (state, { payload = {} }) => {
      state.userInformation = {
        customerName: payload.fullName,
        companyName: payload.companyName,
        companyAddress: payload.companyAddress,
        invoiceReceivingEmail: payload.companyEmail,
        taxCode: payload.companyTaxCode,
        phone: payload.companyPhone,
      }
      state.loading.getUserProfile = false
    })
    builder.addCase(getUserProfile.rejected, (state, action) => {
      state.loading.getUserProfile = action.payload.loading
    })
    //
    builder.addCase(getTerms.pending, (state) => {
      state.terms = ''
      state.loading.getTerms = true
    })
    builder.addCase(getTerms.fulfilled, (state, { payload = {} }) => {
      state.terms = payload
      state.loading.getTerms = false
    })
    builder.addCase(getTerms.rejected, (state, action) => {
      state.loading.getTerms = action.payload.loading
    })
  },
})

export const selectFactSheetId = (state) =>
  covertObjBooleanToArr(state[slice.name].data.factSheet.ids)

export const selectFactSheetData = (state) =>
  state[slice.name].data.factSheet?.byId

export const selectFactSheetDetail = (id) => (state) =>
  state[slice.name].data.factSheet.byId[id]

export const selectBusinessCreditReportId = (state) =>
  covertObjBooleanToArr(state[slice.name].data.businessCreditReport.ids)

export const selectBusinessCreditReportDetail = (id) => (state) =>
  state[slice.name].data.businessCreditReport.byId[id]

export const selectCheck = (state) => state[slice.name].data.check
export const selectCheckIds = (state) =>
  covertObjBooleanToArr(state[slice.name].data.check)

export const selectTotalPrice = (type) => (state) =>
  state[slice.name].data.total[type]

export const selectIsCheck = (id) => (state) => state[slice.name].data.check[id]

export const selectUserInformationValue = (key) => (state) =>
  key
    ? state[slice.name].userInformation[key]
    : state[slice.name].userInformation

export const selectSimilarCompany = (state) =>
  state[slice.name].suggestionCompany.similarCompany

export const selectLinkageCompany = (state) =>
  state[slice.name].suggestionCompany.linkageCompany

export const selectPopularCompany = (state) =>
  state[slice.name].suggestionCompany.popularCompany

export const selectLoading = (type) => (state) =>
  state[slice.name].loading[type]

export const selectDiscountOrder = (state) => state[slice.name].discountOrder
export const selectVoucher = (state) => state[slice.name].dataVoucher
export const selectCheckDisCountAndVoucher = (state) =>
  state[slice.name].checkDisCountAndVoucher
export const selectDataPlaceOrder = (state) => {
  return handleDataPlaceOrder(state[slice.name].data)
}
export const selectDataByTypeReport = (state) => {
  return handleDataByTypeReport(state[slice.name].data)
}
export const selectUserPackage = (state) => state[slice.name].userPackage
export const selectDisableOrder = (state) => state[slice.name].disableOrder
export const selectCheckRules = (state) => state[slice.name].isCheckRules
export const selectFragmentCart = (state) => state[slice.name].fragmentCart
export const selectParamsScreeningReport = (state) =>
  state[slice.name].paramsScreeningReport
export const getDefaultFormFactSheet = (state) =>
  state[slice.name].defaultFormFactSheet
export const selectCodeBankTransfer = (state) =>
  state[slice.name].codeBankTransfer
export const selectTerms = (state) => state[slice.name].terms
export const selectParamsDiscount = (state) => state[slice.name].paramsDiscount

export const {
  resetStore,
  checkItem,
  checkListItem,
  uncheckItem,
  checkAll,
  uncheckAll,
  changeUserInformation,
  changeDataReport,
  getPrice,
  changeCheckDiscountAndVoucher,
  changeDisableOrder,
  changeCheckRules,
  changeFragment,
  getParamsScreeningReport,
  changeDefaultFormFactSheet,
  changeParamsDiscount,
  changeVoucher,
} = slice.actions

register(slice.name, slice.reducer)
